
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import { applyStyle } from 'ol-mapbox-style';
import { Style, Fill, Stroke, Text } from 'ol/style';
import { FeatureLike } from "ol/Feature";
import { mapState } from '../map';
import { getDigitaleKatastralmappeSource } from './digitaleKatastralmappe';
 


const hoverStyle = new Style({
    stroke: new Stroke({
        color: 'rgba(102,255,255,0.8)',
        width: 4,
    }),
  });
  
  // The search layer visualizes the search results.
   export const hoverLayer = new VectorTileLayer({
    renderMode: 'vector',
    source: getDigitaleKatastralmappeSource(),
    declutter:true,
    style: (feature, resolution) => {
         if (feature  && mapState.hoverFeature && (mapState.hoverFeature.get('gnr') === feature.get('gnr') && mapState.hoverFeature.get('kg') === feature.get('kg'))) {
            return hoverStyle;
         }  else {
            return [];
        }
    }, 
    visible:true  
  }); 